import React from 'react';

import styled from 'styled-components';

import { en } from 'localization';

import emblemNavy from './emblem-navy.png';
import logoWordmarkNavy from './logo-wordmark-navy.png';

// Approved brand assets copied from the design skill — never redrawn or
// regenerated.
const WordmarkImage = styled.img`
  display: block;
  height: 1.75rem;
  width: auto;
`;

const EmblemImage = styled.img`
  display: block;
  height: 1.5rem;
  width: auto;
`;

export const BrandWordmark: React.FC = () => (
  <WordmarkImage alt={en.brand.wordmarkAlt} src={logoWordmarkNavy} />
);

// Decorative next to adjacent brand text, so it stays hidden from the
// accessibility tree.
export const BrandEmblem: React.FC = () => (
  <EmblemImage alt="" aria-hidden src={emblemNavy} />
);
